import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, DismissKnowledgeSuggestionResponseDataSchema } from "schema"
import { z } from "zod"
import { knowledgeSuggestionsQuery } from "./knowledgeSuggestionsQuery"

const SKIP_CONFIRMATION_STORAGE_KEY = "permut-knowledge-suggestions-skip-dismiss-confirmation"

export function useDismissKnowledgeSuggestionMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (gapId: string) => {
      const { data } = await axios.post<
        DataResponse<z.infer<typeof DismissKnowledgeSuggestionResponseDataSchema>>
      >(`/knowledgeBase/suggestions/${gapId}/dismiss`)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: knowledgeSuggestionsQuery().queryKey })
    },
  })
}

export function getShouldSkipDismissConfirmation() {
  return localStorage.getItem(SKIP_CONFIRMATION_STORAGE_KEY) === "true"
}

export function storeShouldSkipDismissConfirmation(shouldSkip: boolean) {
  if (shouldSkip) localStorage.setItem(SKIP_CONFIRMATION_STORAGE_KEY, "true")
  else localStorage.removeItem(SKIP_CONFIRMATION_STORAGE_KEY)
}
